export const DEFAULT_COURSE_PRICE_TERM = 90;